/* eslint-disable */
import React, { useEffect, useState, useMemo } from 'react';
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';

import toast from 'react-hot-toast';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWalking, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import { Button, FlexBox, Modal, Spacer, Text } from '@eltoro-ui/components';
import { RadioButtonCustom } from '@eltoro-ui/components/RadioButtonCustom';
import { SummaryTotal } from 'Components/SummaryCart';
import { CreditModal } from 'Components/CreditModal';
import AddCard from 'Pages/MyProfile/components/BillingSection/components/AddCard/AddCard';
import UsedAudienceModal from 'Components/SummaryCart/UsedAudienceModal';
import SummaryEditModal from './SummaryEditModal';
import Tooltip from 'rc-tooltip';
import moment from 'moment';

import plusIcon from 'assets/Images/addcard.png';
import cross from 'assets/Images/cross.png';
import banner from 'assets/Images/Group870623.png';
import succesTick from 'assets/Images/Group87260.png';
import Lefticon from 'assets/Images/honeycombleft.png';
import Righticon from 'assets/Images/honeycombright.png';
import leftGroup from 'assets/Images/leftgroup.svg';
import rightGroup from 'assets/Images/rightgroup.svg';
import video from 'assets/Images/Subtract22.png';
import addcardbill from 'assets/Images/addcardbill.png';
import { faExclamationCircle, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons';
import { faLink, faPen } from '@fortawesome/pro-regular-svg-icons';
import EditClickUrl from 'Pages/CampaignCreation/components/GeneratedCampaign/EditClickUrl';
import EditGeneratedCampaignFlightDate from 'Pages/CampaignCreation/components/GeneratedCampaign/EditGeneratedCampaignFlightDate';
import GeneratedCreativesMobile from 'Pages/CampaignCreation/components/GeneratedCampaign/GeneratedCampaignContent/GeneratedCreativesMobile';

import { getPaymentCards, postCampaignBudget } from 'Requests';
import {
  brand,
  formatToUTC,
  formatToUTCEndDate,
  isValidWorkingDay,
  returnHttpsPrefix,
} from 'Utils/helpers';
import { BANNER_CPM, BANNER_FREQ, DEFAULT_MIN_FLIGHT_DATES, VIDEO_FREQ } from 'Utils/constants';
import type { CampaignType, GeneratedCampaignType, TRootState } from 'types';
import './SummaryCart.scss';
import classNames from 'classnames';
import { checkoutSubmitGeneratedCampaign } from 'Requests/Request_Methods/campaignMethods';

type SummaryCartProps = {
  setCampaignCostAccData?: any;
  campaignCostAccData?: any;
  isCheckout?: boolean;
  days?: number;
  isGenerationFlow?: boolean;
  selectedItems?: string[];
  changedBannerFiles?: { id: string; file: File }[];
};

export const SummaryCart: FC<SummaryCartProps> = ({
  setCampaignCostAccData,
  campaignCostAccData,
  days = DEFAULT_MIN_FLIGHT_DATES,
  isCheckout = false,
  isGenerationFlow,
  selectedItems,
  changedBannerFiles,
}) => {
  const setup = useRouteMatch('/create-campaign/:campaignId/setup');
  const creatives = useRouteMatch('/create-campaign/:campaignId/creatives');
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const {
    startDate,
    endDate,
    bannerCPM,
    videoCPM,
    bannerFreq = BANNER_FREQ,
    videoFreq = VIDEO_FREQ,
    campaign,
    minFlightDuration,
    changedAudiences,
    excludedAudiences,
    isConfirmed,
    clickUrl,
  } = campaignCostAccData || {};
  const generatedAudiences = campaignCostAccData.campaign.audiences;
  const suggestedDaysForGeneratedCampaign = campaignCostAccData.suggestedDates;
  const campaigns = isGenerationFlow ? campaign.campaign : campaign;
  const { userData } = useSelector<TRootState, TRootState['userReducer']>(
    state => state.userReducer
  );
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const [openSubmitModal, setOpenSubmitModal] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [isCreditBuy, setIsCreditBuy] = useState(false);
  const [checkoutLoaded, isCheckoutLoaded] = useState(false);
  const [isSelectCard, setIsSelectCard] = useState(false);
  const [isAddCard, setIsAddCard] = useState(false);
  const [loading, setLoading] = useState(true);
  const [seletedCardId, setSeletedCardId] = useState('');
  const [card, setCard] = useState<any>([]);
  const [openActiveAudienceModal, setOpenActiveAudienceModal] = useState(false);
  const [openEditClickUrlModal, setOpenEditClickUrlModal] = useState(false);
  const [openEditDateModal, setOpenEditDateModal] = useState(false);

  const formattedDateRange = `${moment(startDate).format('MM/DD/YYYY')} - ${moment(endDate).format(
    'MM/DD/YYYY'
  )}`;
  const durationInDays = moment(endDate).add({ days: 1 }).diff(moment(startDate), 'days');

  const cartProspectCount = useMemo(() => {
    let count = campaigns?.prospects_counts;

    if (changedAudiences?.length || excludedAudiences?.length) {
      const pastAndFutureAudineces = [...campaigns.audience, ...changedAudiences].filter(
        item => !excludedAudiences.includes(item.id)
      );
      const seenIds = new Set();
      const uniqueAudiencesArr = [];

      for (let i = pastAndFutureAudineces.length - 1; i >= 0; i--) {
        const item = pastAndFutureAudineces[i];
        if (!seenIds.has(item.id)) {
          seenIds.add(item.id);
          uniqueAudiencesArr.unshift(item); // Add to the beginning to preserve order
        }
      }

      count = uniqueAudiencesArr.reduce(
        (accumulator: any, current: { prospects_counts: any }) =>
          accumulator + current.prospects_counts,
        0
      );
    }

    return count;
  }, [campaigns?.prospects_counts, changedAudiences, campaigns?.audience, excludedAudiences]);

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getImpressions = (): {
    banner_imp: number;
    video_imp: number;
    impressions: number;
  } => {
    const banner_imp = campaigns?.banner_count ? bannerFreq * days * cartProspectCount : 0;
    const video_imp = campaigns?.video_count ? videoFreq * days * cartProspectCount : 0;
    const impressions =
      banner_imp && video_imp ? banner_imp + video_imp : banner_imp ? banner_imp : video_imp;
    return { impressions, banner_imp, video_imp };
  };

  const getCardDetail = () => {
    getPaymentCards().then(res => {
      const data = res.data?.details;
      /* @ts-ignore */
      setCard(data);
      /* @ts-ignore */
      setSeletedCardId(res?.data?.details[0].id || '');
      setLoading(false);
    });
  };

  useEffect(() => {
    getCardDetail();

    return () => {
      setCard([]);
      setSeletedCardId('');
      setLoading(false);
    };
  }, []);

  function bannerCost() {
    if (campaigns?.banner_count >= 1) {
      const data = (cartProspectCount * days * bannerFreq) / 1000;
      return data * bannerCPM;
    }
    return 0;
  }

  function generatedBannerCost() {
    const CPM = BANNER_CPM;
    const currentBudget = campaigns.budget;
    const totalProspects = campaigns.prospects_counts;
    const suggestedDays = suggestedDaysForGeneratedCampaign;

    // Step 1: Calculate initial frequency based on fixed budget
    let FREQ = (currentBudget * 1000) / (CPM * totalProspects * suggestedDays);
    let IMP;

    // Step 2: Calculate impressions based on this frequency
    if (FREQ < 1) {
      // If frequency is less than 1, we set it to 1 (minimum viable frequency)
      FREQ = 1;
    }

    // Step 3: Calculate impressions and return cost based on FREQ
    IMP = FREQ * totalProspects * suggestedDays;
    return { cost: +((CPM / 1000) * IMP).toFixed(2), bannerFreq: FREQ, bannerImp: IMP };
  }
  function videoCost() {
    if (campaigns?.video_count >= 1) {
      const data = (cartProspectCount * days * videoFreq) / 1000;
      return data * videoCPM;
    }
    return 0;
  }

  function creditsPerMile(): any {
    if (isGenerationFlow) {
      return generatedBannerCost();
    } else return bannerCost() + videoCost();
  }

  function totalBudget() {
    if (isGenerationFlow) {
      return generatedBannerCost().cost;
    } else if (campaigns?.banner_count || campaigns?.video_count) creditsPerMile();
    return creditsPerMile();
  }

  const diff = userData?.addons_credits - totalBudget();

  const History = useHistory();

  const postBudget = () => {
    isCheckoutLoaded(true);
    const { impressions, video_imp, banner_imp } = getImpressions() || {};
    const now = new Date();
    const start_Date = new Date(startDate).getTime();
    const ToDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();

    const start_date =
      start_Date === ToDay
        ? formatToUTC(new Date())
        : formatToUTC(startDate) || campaigns?.start_date;

    const end_date = formatToUTCEndDate(endDate);

    const data = {
      start_date,
      end_date,
      days: days || campaigns?.date,
      budget: parseFloat(totalBudget().toFixed(2)),
      video_imp: +video_imp.toFixed(2),
      banner_imp: +banner_imp.toFixed(2),
      impressions_perday: 3 || campaigns?.impressions_perday,
      payment_source_id: seletedCardId,
      video_imp_frequency: videoFreq,
      banner_imp_frequency: bannerFreq,
      changed_audiences: changedAudiences.map((item: { id: number; prospects_counts: number }) => ({
        audience_id: item.id,
        prospects_count: item.prospects_counts,
      })),
      excluded_audiences: excludedAudiences,
      impressions: 0,
    };

    const formData = new FormData();

    const body = {
      banner_click_url: returnHttpsPrefix(clickUrl),
      banner_uuids: selectedItems?.filter(
        uuid => !changedBannerFiles?.find(({ id }) => id === uuid)
      ),
      start_date,
      end_date,
      days: suggestedDaysForGeneratedCampaign,
      budget: parseFloat(totalBudget().toFixed(2)),
      banner_imp: generatedBannerCost().bannerImp,
      banner_imp_frequency: generatedBannerCost().bannerFreq,
      payment_source_id: seletedCardId,
    };

    formData.append('body', JSON.stringify(body));

    changedBannerFiles?.forEach(({ id, file }) => {
      if (selectedItems?.findIndex(bannerUUID => bannerUUID === id) !== -1) {
        formData.append('banners', file);
      }
    });

    const request = isGenerationFlow
      ? checkoutSubmitGeneratedCampaign(campaigns?.id, formData)
      : postCampaignBudget(campaigns?.id, data);
    request
      .then((res: any) => {
        if (res.detail) {
          toast.error(res.detail);
        }
        if (res?.data?.status === 'Creating') {
          setOpenSubmitModal(true);
        }
        isCheckoutLoaded(false);
      })
      .catch((err: any) => {
        if (err.detail && err.detail === 'Audience is in use in another campaign') {
          isCheckoutLoaded(false);
          setOpenActiveAudienceModal(true);
        } else {
          toast.error(err.detail);
          isCheckoutLoaded(false);
        }
      });
  };

  const findCreatives = (creativeType: string) => {
    return campaigns?.creatives?.filter(
      (creat: { content_type: string }) => creat.content_type === creativeType
    );
  };

  useEffect(() => {
    if (isCreditBuy) {
      toast.success('Credits has been added to your account');
      setIsCreditBuy(false);
    }
  }, [isCreditBuy]);

  const isActionDisabled =
    days < minFlightDuration || days < DEFAULT_MIN_FLIGHT_DATES || checkoutLoaded;

  const handleConfirmChanges = (updatedData: any) => {
    const {
      startDate,
      endDate,
      minDays: minFlightDuration,
      bannerFreq,
      videoFreq,
      excludedAudiences,
      changedAudiences,
    } = updatedData || {};

    setCampaignCostAccData((prev: any) => ({
      ...prev,
      startDate,
      endDate,
      minFlightDuration,
      bannerFreq,
      videoFreq,
      excludedAudiences,
      changedAudiences,
      isConfirmed: true,
    }));

    setEditModalOpen(false);
  };

  const cartAudienceCount = useMemo(() => {
    let count = campaigns?.audience_count;

    if (excludedAudiences?.length) {
      count = count - excludedAudiences.length;
    }

    return count;
  }, [campaigns?.audience_count, excludedAudiences]);

  const handleGeneratedBannerFlightDateChange = (
    startDate: Date | string,
    endDate: Date | string,
    suggestedDates: number
  ) => {
    setCampaignCostAccData((prev: any) => ({
      ...prev,
      startDate,
      endDate,
      suggestedDates,
    }));
  };
  const handleGeneratedBannerUrlChange = (clickUrl: string) => {
    setCampaignCostAccData((prev: any) => ({
      ...prev,
      clickUrl,
    }));
  };
  return (
    <div className={classNames('SummaryCart', isGenerationFlow && 'fullHeightCart')}>
      {isGenerationFlow && <GeneratedCreativesMobile campaignData={campaignCostAccData.campaign} />}
      {isGenerationFlow && <div className="divider" />}
      <div>
        <FlexBox
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          padding="0 1.5rem 1rem"
          UNSAFE_className="summary"
          backgroundColor="#FFFFFF"
        >
          <Text size="xxl" on="white" weight="bold" UNSAFE_className="Summary_heading">
            Summary
          </Text>
          {isConfirmed && (
            <FlexBox
              justifyContent="space-between"
              alignItems="center"
              UNSAFE_style={{
                border: '1px solid #FA8C16',
                borderRadius: '6px',
                padding: '12px',
                marginTop: '1rem',
              }}
              gap="15px"
            >
              <FontAwesomeIcon icon={faExclamationTriangle} color="#FA8C16" />
              <Text on="white" textAlign="left" UNSAFE_style={{ color: '#757575', fontSize: 14 }}>
                Changes you’ve made while editing final spend will not be saved unless you checkout
                and submit.
              </Text>
            </FlexBox>
          )}
        </FlexBox>
        {campaigns?.audiences?.length ||
        campaigns?.audience_count >= 1 ||
        campaigns?.audiences?.length >= 1 ||
        generatedAudiences?.length >= 1 ? (
          <>
            <div className="SummaryCart__header-item">
              <Text on="grey-100" weight="bold" UNSAFE_className="SummaryCart__save_audience">
                Audience
              </Text>
            </div>
            <div className="SummaryCart__body-item">
              <Text UNSAFE_className="SummaryCart__body-item__overall_font" on="grey-050">
                <FontAwesomeIcon icon={faWalking} color="var(--color-secondary-300)" />
                <span className="SummaryCart__prospects_heading">
                  {cartProspectCount} Prospects
                </span>
                <span className="SummaryCart__prospects_subheading">
                  ({cartAudienceCount || campaigns?.audiences}{' '}
                  {`Audience${cartAudienceCount > 1 ? 's' : ''}`})
                </span>
              </Text>
            </div>
          </>
        ) : (
          ''
        )}

        {openSubmitModal ? (
          <Modal>
            <FlexBox
              flexDirection="column"
              gap="2rem"
              UNSAFE_className="OnboardingModal-welcome SummaryCart__submitModal"
              UNSAFE_style={{ position: 'relative' }}
            >
              <img className="SummaryCart__lefticon" src={Lefticon} alt="lefticon" />
              <FlexBox
                UNSAFE_className="OnboardingModal-welcomeHeader SummaryCart__submitModalContent"
                gap="2rem"
                flexDirection="column"
              >
                <div className="successTick">
                  <img src={succesTick} alt="successTick" />
                </div>
                <div className="SummaryCart__title_container">
                  <Text UNSAFE_className="SummaryCart__title" on="white" textAlign="center">
                    Your Campaign Is Submitted For Review
                  </Text>
                </div>
              </FlexBox>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '10px',
                }}
              >
                <Button
                  UNSAFE_style={{ padding: '30px 30px' }}
                  kind="primary"
                  size="xl"
                  width="50%"
                  weight="bold"
                  onClick={() => {
                    setOpenSubmitModal(false);
                    History.push(
                      deviceWidth >= 800 ? '/orderlines?filter=campaigns' : '/dashboard',
                      {
                        refreshData: true,
                      }
                    );
                  }}
                  UNSAFE_className="SummaryCart__Back_to_campaigns"
                >
                  {deviceWidth >= 800 ? 'Go to Campaigns' : 'Back to Dashboard'}
                </Button>
              </div>
              <img className="SummaryCart__rigticon" src={Righticon} alt="righticon" />
            </FlexBox>
          </Modal>
        ) : (
          ''
        )}
        {/* Creatives Type */}
        {(campaigns?.creatives?.length > 0 ||
          (selectedItems && selectedItems.length > 0) ||
          campaigns?.banner_count ||
          campaigns?.video_count ||
          campaigns?.direct_mail_count) &&
        (creatives || isCheckout) ? (
          <>
            <div className="SummaryCart__header-item">
              <Text on="grey-100" weight="bold" UNSAFE_className="SummaryCart__save_audience">
                Creative
              </Text>
            </div>
            {selectedItems && selectedItems.length > 0 ? (
              <div className="SummaryCart__body-item creative_tile">
                <div className="creative_item">
                  <Text UNSAFE_className="SummaryCart__content_heading" on="grey-050">
                    <img src={banner} alt="" className="SummaryCart__itemImage" />
                    {selectedItems?.length >= 1 && `${selectedItems?.length}`} Digital Banner
                    {selectedItems?.length > 1 ? 's' : ''}
                  </Text>
                  <Tooltip
                    placement="top"
                    trigger={deviceWidth > 600 ? 'hover' : 'click'}
                    showArrow
                    align={{
                      offset: deviceWidth > 600 ? [-20, -3] : [-50, -3],
                      targetOffset: [-6, 0],
                    }}
                    overlay={
                      <div>
                        This banner ad will be served to each prospect{' '}
                        {generatedBannerCost().bannerFreq.toFixed(2)} times per day.
                      </div>
                    }
                  >
                    <span>
                      <FontAwesomeIcon icon={faExclamationCircle} />
                    </span>
                  </Tooltip>
                </div>
              </div>
            ) : (
              <>
                {findCreatives('video')?.length !== 0 && (
                  <div className="SummaryCart__body-item creative_tile">
                    <div className="creative_item">
                      <Text on="grey-050" UNSAFE_className="SummaryCart__content_heading">
                        <img src={video} alt="" className="SummaryCart__itemImage" />
                        {findCreatives('video')?.length >= 1 &&
                          `${findCreatives('video')?.length}`}{' '}
                        Video{findCreatives('video')?.length > 1 ? 's' : ''}
                      </Text>
                      <Tooltip
                        placement="top"
                        trigger={deviceWidth > 600 ? 'hover' : 'click'}
                        showArrow
                        align={{
                          offset: deviceWidth > 600 ? [-20, -3] : [-50, -3],
                          targetOffset: [-6, 0],
                        }}
                        overlay={
                          <div>
                            This video ad will be served to each prospect {videoFreq.toFixed(2)}{' '}
                            times per day.
                          </div>
                        }
                        getTooltipContainer={() => document.body}
                      >
                        <span>
                          <FontAwesomeIcon icon={faExclamationCircle} />
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                )}

                {findCreatives('banner')?.length !== 0 && (
                  <div className="SummaryCart__body-item creative_tile">
                    <div className="creative_item">
                      <Text UNSAFE_className="SummaryCart__content_heading" on="grey-050">
                        <img src={banner} alt="" className="SummaryCart__itemImage" />
                        {findCreatives('banner')?.length >= 1 &&
                          `${findCreatives('banner')?.length}`}{' '}
                        Digital Banner{findCreatives('banner')?.length > 1 ? 's' : ''}
                      </Text>
                      <Tooltip
                        placement="top"
                        trigger={deviceWidth > 600 ? 'hover' : 'click'}
                        showArrow
                        align={{
                          offset: deviceWidth > 600 ? [-20, -3] : [-50, -3],
                          targetOffset: [-6, 0],
                        }}
                        overlay={
                          <div>
                            This banner ad will be served to each prospect {bannerFreq.toFixed(2)}{' '}
                            times per day.
                          </div>
                        }
                      >
                        <span>
                          <FontAwesomeIcon icon={faExclamationCircle} />
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          ''
        )}

        {isCheckout && (
          <>
            <div className="SummaryCart__header-item">
              <Text on="grey-100" weight="bold" UNSAFE_className="SummaryCart__save_audience">
                Flight Dates
              </Text>
            </div>
            <div className="SummaryCart__body-item">
              <FlexBox justifyContent={'space-between'}>
                <Text UNSAFE_className="SummaryCart__content_heading" on="grey-050">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    color="#FFAB03"
                    style={{ fontSize: '20px', marginRight: '10px' }}
                  />
                  {`${formattedDateRange} (${durationInDays} day${durationInDays > 1 ? 's' : ''})`}
                  {isGenerationFlow && (
                    <Button kind="link" onClick={() => setOpenEditDateModal(true)}>
                      <FontAwesomeIcon icon={faPen} fontSize={14} color={'#007B94'} />
                    </Button>
                  )}
                </Text>
                {isGenerationFlow && (
                  <Tooltip
                    placement="top"
                    trigger={deviceWidth > 600 ? 'hover' : 'click'}
                    showArrow
                    align={{
                      offset: deviceWidth > 600 ? [-20, -3] : [-50, -3],
                      targetOffset: [-6, 0],
                    }}
                    overlay={
                      <div>
                        Please note: Campaigns submitted outside of company working hours or on
                        non-working days (e.g., after hours or on Fridays) will be reviewed on the
                        next business day.
                      </div>
                    }
                  >
                    <span>
                      <FontAwesomeIcon icon={faExclamationCircle} />
                    </span>
                  </Tooltip>
                )}
              </FlexBox>
            </div>
          </>
        )}
        {isGenerationFlow && clickUrl && (
          <>
            <div className="SummaryCart__header-item">
              <Text on="grey-100" weight="bold" UNSAFE_className="SummaryCart__save_audience">
                ClickThrough URL
              </Text>
            </div>
            <div className="SummaryCart__body-item">
              <FlexBox justifyContent="space-between">
                <Text UNSAFE_className="SummaryCart__content_heading" on="grey-050">
                  <FontAwesomeIcon
                    icon={faLink}
                    color="#FFAB03"
                    style={{ fontSize: '20px', marginRight: '10px' }}
                  />
                  {clickUrl}
                  <Button kind="link" onClick={() => setOpenEditClickUrlModal(true)}>
                    <FontAwesomeIcon icon={faPen} fontSize={14} color={'#007B94'} />
                  </Button>
                </Text>
                <Tooltip
                  placement="top"
                  trigger={deviceWidth > 600 ? 'hover' : 'click'}
                  showArrow
                  align={{
                    offset: deviceWidth > 600 ? [-20, -3] : [-50, -3],
                    targetOffset: [-6, 0],
                  }}
                  overlay={
                    <div>
                      This is the link that takes users to your landing page when they click your
                      ad.
                    </div>
                  }
                >
                  <span>
                    <FontAwesomeIcon icon={faExclamationCircle} />
                  </span>
                </Tooltip>
              </FlexBox>
            </div>
          </>
        )}
      </div>
      {(totalBudget() || campaigns?.budget) && !setup && !creatives ? (
        <FlexBox flexDirection="column">
          <div className="summary-total">
            <div className="SummaryCart__total_budget">
              <SummaryTotal
                isEditDisabled={isActionDisabled}
                total={totalBudget().toFixed(2) || campaigns?.budget.toFixed(2)}
                handleOpen={() => setEditModalOpen(true)}
                isGenerationFlow={isGenerationFlow}
              />
            </div>
            <Spacer />
            <FlexBox paddingRight="1.5rem" paddingLeft="1.5rem" flexDirection={'column'}>
              {isGenerationFlow && selectedItems && !selectedItems.length ? (
                <Tooltip
                  placement="top"
                  trigger={deviceWidth > 600 ? 'hover' : 'click'}
                  showArrow
                  overlay={'Please include at least one banner to proceed with checkout.'}
                  getTooltipContainer={() => document.body}
                >
                  <Button
                    size="xl"
                    kind="primary"
                    width="100%"
                    weight="bold"
                    UNSAFE_className="checkout_and_submit"
                    disabled={
                      isActionDisabled ||
                      isValidWorkingDay(startDate) ||
                      (isGenerationFlow && selectedItems && !selectedItems.length)
                    }
                    loading={checkoutLoaded}
                    onClick={() => setIsSelectCard(true)}
                  >
                    {isGenerationFlow && selectedItems && selectedItems.length > 0
                      ? `Checkout with ${selectedItems.length} ads`
                      : isGenerationFlow && selectedItems && !selectedItems.length
                      ? 'Checkout'
                      : 'Checkout and Submit'}
                  </Button>
                </Tooltip>
              ) : (
                <Button
                  size="xl"
                  kind="primary"
                  width="100%"
                  weight="bold"
                  UNSAFE_className="checkout_and_submit"
                  disabled={
                    isActionDisabled ||
                    isValidWorkingDay(startDate) ||
                    (isGenerationFlow && selectedItems && !selectedItems.length)
                  }
                  loading={checkoutLoaded}
                  onClick={() => setIsSelectCard(true)}
                >
                  {isGenerationFlow && selectedItems && selectedItems.length > 0
                    ? `Checkout with ${selectedItems.length} ads`
                    : isGenerationFlow && selectedItems && !selectedItems.length
                    ? 'Checkout'
                    : 'Checkout and Submit'}
                </Button>
              )}
              {isGenerationFlow && selectedItems && selectedItems.length < 3 && (
                <div className="select-info">
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    color="#007B94"
                    style={{ fontSize: '16px' }}
                  />
                  We recommend you serve at least 3 sizes
                </div>
              )}
            </FlexBox>
          </div>
          {isSelectCard && (
            <Modal style={{ position: 'relative' }} offClick={() => setIsSelectCard(false)}>
              <div className="SummaryCart__AddCardModal">
                <img className="SummaryCart__leftcardicon" src={leftGroup} alt="leftcardicon" />
                <img className="SummaryCart__righcardicon" src={rightGroup} alt="righcardicon" />
                <img
                  className="BillingSection__cross"
                  onClick={() => setIsSelectCard(false)}
                  src={cross}
                  alt="cross"
                />
                {/* @ts-ignore */}
                {/* <AddCard /> */}
                <div className="SummaryCart__allCardlist">
                  <Text on="white" UNSAFE_className="SummaryCart__addCardHeading">
                    {/* @ts-ignore */}
                    {!card.length ? 'Add Card' : 'Select Card'}
                  </Text>
                  {!card.length ? (
                    <div className="BillingSection__main">
                      <img
                        className="BillingSection__billingIcon"
                        src={addcardbill}
                        alt="addcardbill"
                      />
                      <Button
                        type="button"
                        kind="primary"
                        size="m"
                        weight="bold"
                        UNSAFE_className="BillingSection__billingButton"
                        onClick={() => {
                          setIsAddCard(true);
                        }}
                      >
                        Add Card
                      </Button>
                    </div>
                  ) : (
                    <>
                      <div className="SummaryCart__allCardlist_heading">
                        <div className="SummaryCart__heading_section">
                          <Text on="white" UNSAFE_className="SummaryCart__heading_text">
                            Card Detail
                          </Text>
                        </div>

                        <Text on="white" UNSAFE_className="SummaryCart__heading_text">
                          Expiry Date
                        </Text>
                      </div>
                      <div className="SummaryCart__card_list Modal__scrollable-content">
                        {card?.map((item: any) => (
                          <div
                            key={item.id}
                            className={
                              seletedCardId === item.id
                                ? 'SummaryCart__detailsCard_id'
                                : 'SummaryCart__detailsCard'
                            }
                          >
                            <div className="SummaryCart__billing_card">
                              <RadioButtonCustom
                                isCircular
                                checked={seletedCardId === item.id}
                                onChange={checked => setSeletedCardId(item.id)}
                              />
                              <img
                                className="SummaryCart__billing_card_brand-icon"
                                src={brand(item?.card.brand)}
                                alt={item?.card?.brand}
                              />
                              <div className="SummaryCart__billing_card_left">
                                <Text on="white" UNSAFE_className="SummaryCart__card_detail_text">
                                  {item?.card?.masked_number}
                                </Text>
                                <Text on="white" UNSAFE_className="SummaryCart__card_detail_text">
                                  {`${item?.card?.first_name} ${item?.card?.last_name}`}
                                </Text>
                              </div>
                            </div>
                            <div className="">
                              <Text on="white" UNSAFE_className="SummaryCart__heading_text_detail">
                                {`${item?.card?.expiry_month}/${item?.card?.expiry_year}`}
                              </Text>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        className="SummaryCart__addCard"
                        onClick={() => {
                          setIsAddCard(true);
                          setIsSelectCard(false);
                        }}
                      >
                        <button className="SummaryCart__headingButton" type="button">
                          <img src={plusIcon} alt="uploadicon" style={{ marginRight: '10px' }} />{' '}
                          Add Card
                        </button>
                      </div>
                      <Button
                        kind="primary"
                        width="30%"
                        weight="bold"
                        UNSAFE_style={{
                          margin: '1.5rem auto 0 auto',
                        }}
                        UNSAFE_className="summary_card_done"
                        onClick={() => {
                          postBudget();
                          setIsSelectCard(false);
                        }}
                      >
                        Done
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </Modal>
          )}
          {isAddCard && (
            <Modal style={{ position: 'relative' }}>
              <div className="BillingSection__AddCardModal">
                <img
                  style={{
                    position: 'absolute',
                    bottom: '0',
                    right: '0px',
                    width: '29%',
                  }}
                  src={rightGroup}
                  alt="confirmleftcomb"
                />

                <img
                  className="BillingSection__cross"
                  onClick={() => {
                    setIsAddCard(false);
                    setIsSelectCard(true);
                  }}
                  src={cross}
                  alt="cross"
                />
                {/* @ts-ignore */}
                <div className="SummaryCart__campaginCard">
                  <p className="addCardHeading " style={{ marginBottom: '10px' }}>
                    Add Card
                  </p>

                  <AddCard
                    /* @ts-ignore */
                    getCardDetail={getCardDetail}
                    setIsAddCard={setIsAddCard}
                    setLoadings={setLoading}
                    setIsSelectCard={setIsSelectCard}
                  />
                </div>
                <img
                  style={{
                    position: 'absolute',
                    top: '-20px',
                    left: '8px',
                    width: '28%',
                  }}
                  src={leftGroup}
                  alt="lconfirmleftcomb"
                />
              </div>
            </Modal>
          )}

          {checkoutLoaded && (
            <span
              style={{
                color: '#DC9300',
                marginTop: '8px',
                fontSize: '17px',
                fontWeight: 400,
                textAlign: 'center',
              }}
            >
              The campaign is in progress to be created.
            </span>
          )}
          <Spacer />
        </FlexBox>
      ) : (
        ''
      )}

      {creditModalOpen && (
        <CreditModal
          offClick={() => setCreditModalOpen(false)}
          pointsNeeded={diff < 1 ? diff : 0}
          setIsCreditBuy={setIsCreditBuy}
        />
      )}
      {editModalOpen && (
        <SummaryEditModal
          onClose={() => setEditModalOpen(false)}
          bannerCost={bannerCost()}
          videoCost={videoCost()}
          days={days}
          startDate={startDate}
          endDate={endDate}
          onConfirm={handleConfirmChanges}
          minDays={minFlightDuration}
          prospectsCount={cartProspectCount}
          bannerFreq={bannerFreq}
          videoFreq={videoFreq}
          campaign={campaigns}
          excludedAudiences={excludedAudiences}
          changedAudiences={changedAudiences}
        />
      )}
      {openActiveAudienceModal && <UsedAudienceModal campaignId={campaigns.id} />}
      {openEditClickUrlModal && clickUrl !== undefined && (
        <EditClickUrl
          onClose={() => setOpenEditClickUrlModal(false)}
          url={clickUrl}
          handleGeneratedBannerUrlChange={handleGeneratedBannerUrlChange}
        />
      )}
      {openEditDateModal && (
        <EditGeneratedCampaignFlightDate
          onClose={() => setOpenEditDateModal(false)}
          campaignData={campaignCostAccData}
          cost={generatedBannerCost().cost}
          handleGeneratedBannerFlightDateChange={handleGeneratedBannerFlightDateChange}
        />
      )}
    </div>
  );
};
